import classNames from 'classnames'
import { ReactNode, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { ModalDialog } from 'core-components/library/modalDialog'
import {
  AbsolutePopup,
  PopPaper,
  TPopupHorizontal,
  TPopupVertical,
} from 'core-components/library/popup'
import { FlexGridWrapperContext } from 'core-components/sitebuilder/layout/context/FlexGridWrapperContext'
import { LayoutModal } from 'core-components/sitebuilder/layout/flexGridWrapper/settingsButton/LayoutModal'
import { selectEditLayoutMode } from 'core-components/sitebuilder/store/selectors/selectEditLayoutMode'
import { setEditLayoutMode } from 'core-components/sitebuilder/store/siteBuilderSlice'

import styles from './SettingsButton.module.scss'

interface ICustomContent {
  close: () => void
  buttonClass: string
}

interface ISettingsButton {
  customContent?: (data: ICustomContent) => ReactNode
}

let PAGE_SETTINGS_MOUNTED_COUNT = 0

export const getPageSettingsCountOnPage = () => PAGE_SETTINGS_MOUNTED_COUNT

export const SettingsButton = ({ customContent }: ISettingsButton) => {
  const { canEditSettings, isAnonymous } = useContext(FlexGridWrapperContext)
  const editLayoutMode = useSelector(selectEditLayoutMode)
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState<boolean>(false)

  useEffect(() => {
    PAGE_SETTINGS_MOUNTED_COUNT++
    return () => {
      PAGE_SETTINGS_MOUNTED_COUNT--
    }
  }, [])

  if (isAnonymous) {
    return null
  }

  return (
    <div className={styles.root}>
      <AbsolutePopup
        popupClassName={styles.popupWrap}
        rootClassName={styles.popupRoot}
        horizontalStartPosition={TPopupHorizontal.Right}
        horizontalDirection={TPopupHorizontal.Left}
        verticalStartPosition={TPopupVertical.Bottom}
        popupContent={(contentData) => (
          <PopPaper>
            <Flex flexDirection={'column'} gap={'none'}>
              <Button
                className={styles.item}
                variant={'text'}
                color={'grey'}
                disabled={!canEditSettings}
                onClick={() => {
                  contentData.action.close()
                  setOpenModal(true)
                }}
              >
                Change layout
              </Button>
              <Button
                __testId={'flexGridVisibilityButton'}
                className={styles.item}
                variant={'text'}
                color={'grey'}
                disabled={!canEditSettings}
                onClick={() => {
                  contentData.action.close()
                  dispatch(setEditLayoutMode(!editLayoutMode))
                }}
              >
                {editLayoutMode ? 'Hide flex grid settings' : 'Show flex grid settings'}
              </Button>

              {customContent &&
                customContent({ close: contentData.action.close, buttonClass: styles.item })}
            </Flex>
          </PopPaper>
        )}
      >
        <Button
          __testId={'settingsGearButton'}
          id={'settings-gear'}
          className={classNames(styles.btn)}
          variant={'text'}
          color={'grey'}
          iconButton={'kbase kbase-settings'}
        />
      </AbsolutePopup>

      <ModalDialog
        show={openModal}
        size={'md'}
        onClose={() => setOpenModal(false)}
        content={() => <LayoutModal />}
      />
    </div>
  )
}